const GAS_PAYMENT_URL_WITH_CUSTOMER =
  "https://sfselfservice.supergas-power.co.il/s/invoice-payment";

const GAS_PAYMENT_URL_NO_CUSTOMER =
  "https://sfselfservice.supergas-power.co.il/s/gas-invoice-payment";

const SUPERGAS_PAY_URL = "https://paybill.supergas-power.co.il/";

export type GasInvoicePaymentUrlParams = {
  logisticNumber?: string;
  identificationType?: "invoice" | "id" | "phone";
  identificationValue?: string;
  firmCode?: 3;
  iframeUrl?: string;
};

export function buildGasInvoicePaymentUrl({
  logisticNumber,
  identificationType,
  identificationValue,
  firmCode,
  iframeUrl,
}: GasInvoicePaymentUrlParams): string {
  if (iframeUrl) {
    return iframeUrl;
  }

  if (identificationType === "invoice" && firmCode === 3) {
    return SUPERGAS_PAY_URL;
  }

  if (!logisticNumber) {
    return GAS_PAYMENT_URL_NO_CUSTOMER;
  }

  const url = new URL(GAS_PAYMENT_URL_WITH_CUSTOMER);

  url.searchParams.set(
    "logisticNumber",
    btoa(logisticNumber),
  );

  if (identificationType && identificationValue) {
    url.searchParams.set(
      "identificationValue",
      btoa(identificationValue),
    );

    url.searchParams.set(
      "identificationType",
      btoa(identificationType),
    );
  }

  console.log(url.toString());

  return url.toString();
}
